// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-disabled[data-v-676d67f2] {\n  opacity: 0.5;\n}\n.base-wrapper__title[data-v-676d67f2] {\n  font-weight: 500;\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
